import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractColorInput} from "../abstract-color-input";
import {TranslateService} from "@ngx-translate/core";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineColorInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-color-input",
    styleUrls: ["./inline-color-input.component.scss"],
    templateUrl: "./inline-color-input.component.html"
})
export class FUIInlineColorInputComponent extends FUIAbstractColorInput {
    constructor(elementRef: ElementRef,
                eventsService: FUIEventsService,
                translateService: TranslateService,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, eventsService, translateService, changeDetectorRef);
    }
}
